export const contracts = {
    'Arbitrum': {
        send_contract: "0x2F92A44C7d0ef5609E7113671982Cf2abC956d60",
    },
    'Mumbai': {
        send_contract: "0x6772A02640cF85BC32711D18ff60AAA4D948DfAA",
    },
    'Polygon': {
        send_contract: "0x897C7d214fEF07e02Ab997B443c846BBfde1b9DA",
    },
    'Binance': {
        send_contract: "0xF87eFCBB77f93D32201d472A1EdE7dAe8b765Ba3",
    },
    'Ethereum': {
        send_contract: "0xf7F0cc5a1aFD686e891d5c5B033f621B2131B241",
    },
    'Avalanche': {
        send_contract: "0x9f78f4A2c5327896079E9Abb4DE978d8966f8E3B",
    },
    'Base': {
        send_contract: "0x32DD07D68D746864d755Deb9AdAf1a757787F852",
    },
    'Berachain': {
        send_contract: "0x9f78f4A2c5327896079E9Abb4DE978d8966f8E3B",
    },
    'Neurochain': {
        send_contract: "0xaF9e4166F3757eB049c55B1dc5Bb08EF3df6Be58",
    },
}